import React, { PureComponent } from "react";

import { View } from "@zendesk/self-service-components";
import t from "@zendesk/client-i18n-tools";

import styles from "./index.css";

export default class ErrorScreen extends PureComponent {
  render() {
    return (
      <View className={styles.container}>
        <View className={styles.title}>
          {t("knowledge-user-segments.fatalApplicationLoadErrorTitle")}
        </View>
        <View className={styles.body}>
          {t("knowledge-user-segments.fatalApplicationLoadErrorBody")}
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorScreen/index.js